/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import LpDivorceCheck24Meta from "./LpDivorceCheck24Meta";
import Container from "../../../../../components/Container/Container";
import DivorceCheckin from "../../../../../components/Checkin/DivorceCheckin/DivorceCheckin";
import TeamSection from "../../../../../components/Sections/Generic/TeamSection/TeamSection";
import Layout from "../../../../Layouts/Layout";
import PartnerLogoSection from "../../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import BirdMapSection from "../../../../../components/Sections/Divorce/BirdMapSection/BirdMapSection";
import DivorcePlannerSection from "../../../../../components/Sections/Divorce/DivorcePlannerSection/DivorcePlannerSection";
import TrustSection from "../../../../../components/Sections/Generic/TrustSection/TrustSection";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import ServiceSection from "../../../../../components/Sections/Generic/ServiceSection/ServiceSection";
import AdvantagesLegalbirdAttorneySection from "../../../../../components/Sections/Generic/AdvantagesLegalbirdAttorneySection/AdvantagesLegalbirdAttorneySection";
import ProcedureDivorceSection from "../../../../../components/Sections/Divorce/ProcedureDivorceSection/ProcedureDivorceSection";
import ServiceTeaser from "../../../../../components/Teaser/ServiceTeaser";
import GreyBackgroundWrapper from "../../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import { divorceTeaserCards } from "../../../../../services/landingPageService";
import { useCustomer } from "../../../../../provider/Customer/CustomerProvider";

const LpDivorceCheck24 = () => {
  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpDivorceCheck24Meta />
      <LandingPageTeaser
        headline={"Professionell scheiden lassen!"}
        subheadline={"Wir begleiten Sie sicher bei Ihrer Scheidung."}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={divorceTeaserCards} />
      </LandingPageTeaser>
      <PartnerLogoSection partnerName={"check24"} />
      <GreyBackgroundWrapper>
        {!isLoggedIn && (
          <Container>
            <DivorceCheckin idPrefix={"top"} checkinHeading={"Als CHECK24-Kunde jetzt schnell und einfach starten!"} partner={"check24"} />
          </Container>
        )}
        <ServiceSection product={"divorce"} />
        <TeamSection isSubsection={true} />
      </GreyBackgroundWrapper>
      <BirdMapSection />
      <AdvantagesLegalbirdAttorneySection />
      <ServiceTeaser />
      <GreyBackgroundWrapper>
        <DivorcePlannerSection />
        <ProcedureDivorceSection />
      </GreyBackgroundWrapper>
      <TrustSection />
      {!isLoggedIn && (
        <Container>
          <DivorceCheckin idPrefix={"bottom"} checkinHeading={"Als CHECK24-Kunde jetzt schnell und einfach starten!"} />
        </Container>
      )}
    </Layout>
  );
};

export default LpDivorceCheck24;
